import localeConfig from "@/config/localeConfig"
import getSiteFromDomain from "@/vue/planning/logic/getSiteFromDomain"

export default {
    locale: (state) => {
        return localeConfig[state.language]
    },

    isLocaleNL: (state) => {
        const locale = localeConfig[state.language]
        if (locale === 'nl_NL') return true
        // benlyoonly (www.benl.yoonly.eu) is Dutch and sells the same flight packages as NL (9-guest cap).
        return locale === 'nl_NL_YN' && getSiteFromDomain(window.location.hostname) === 'www.benl.yoonly.eu'
    },
    
    isLocaleFR: (state) => {
        return localeConfig[state.language] === 'fr_FR'
    },

    isLocaleEN: (state) => {
        return localeConfig[state.language] === 'en_US'
    }
}